var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3.02878 8.3606L8.48356 12.0056C9.76422 12.8569 10.4045 13.2825 11.0964 13.4479C11.7078 13.5941 12.3451 13.5941 12.9565 13.4479C13.6483 13.2825 14.2887 12.8569 15.5693 12.0056L20.9736 8.40065M7.8 19.3606H16.2C17.8802 19.3606 18.7202 19.3606 19.362 19.0336C19.9265 18.746 20.3854 18.2871 20.673 17.7226C21 17.0808 21 16.2408 21 14.5606V10.1606C21 8.48044 21 7.64036 20.673 6.99862C20.3854 6.43414 19.9265 5.9752 19.362 5.68758C18.7202 5.3606 17.8802 5.3606 16.2 5.3606H7.8C6.11984 5.3606 5.27976 5.3606 4.63803 5.68758C4.07354 5.9752 3.6146 6.43414 3.32698 6.99862C3 7.64036 3 8.48044 3 10.1606V14.5606C3 16.2408 3 17.0808 3.32698 17.7226C3.6146 18.2871 4.07354 18.746 4.63803 19.0336C5.27976 19.3606 6.11984 19.3606 7.8 19.3606Z",
    stroke: "white",
    strokeWidth: 2.42253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.fa75b1afc50198a2cd0cd7b6617784d8.svg";
export { ForwardRef as ReactComponent };